var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "copy_svg__design-iconfont"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#8E939F",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.06 7.9.146 11.4-8.559.2L6.5 8.1l8.56-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94 4.5h8.413c.304 0 .596.126.811.351.215.226.336.53.336.849v10.8",
    strokeLinecap: "round"
  }))));
};
export default SvgCopy;